import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { Grid, DialogContent, Snackbar, Dialog, Button } from "@material-ui/core";
import { Formik, Form, Field } from "formik";
import { TextField } from "formik-material-ui";
import styles from "./subscription.module.css";
import ModalCloseButton from "../../components/UI/ModalCloseButton";
import * as Yup from "yup";
import CheckoutSubscription from "./checkOutSubscription";

let PlayersSchema = Yup.object().shape({
    numberOfPlayers: Yup.number()
        .typeError('Number only')
        .required("Required")
        .test(
            'Is positive?',
            'Invalid',
            (value) => value > 0
        ),
});

export default function AccountModal(props) {
    const { open, setOpen, setAlert } = props
    const [initialValues, setInitialValues] = useState({ numberOfPlayers: 1 });
    const [addMore, setAddMore] = useState(false);
    const [process, setProcess] = useState(false);
    const [blueColorIndex, setBlueColorIndex] = useState(50);
    const [totalCount, setTotalCount] = useState(0);
    const [playersCount, setPlayersCount] = useState(1);
    const [year, setYear] = useState(false);
    const handleClose = () => {
        setAddMore(false);
        setProcess(false);
        setOpen(false);
    }

    const handleChangePlayers = (e) => {
        e.preventDefault();
        const playersCount = e.target.value;
        setPlayersCount(playersCount)
        if (playersCount < 0) {
            setBlueColorIndex(0);
            handleCalculate(playersCount);
            setYear(false)
        } else if (playersCount === '') {
            setBlueColorIndex(0);
            handleCalculate(playersCount);
            setYear(false)
        } else if (playersCount < 26) {
            setBlueColorIndex(50);
            handleCalculate(playersCount);
        } else if (playersCount < 51) {
            setBlueColorIndex(47.5);
            handleCalculate(playersCount);
        } else if (playersCount < 101) {
            setBlueColorIndex(45);
            handleCalculate(playersCount);
        } else if (playersCount < 201) {
            setBlueColorIndex(40);
            handleCalculate(playersCount);
        } else if (playersCount > 200) {
            setBlueColorIndex(35);
            handleCalculate(playersCount);
        } else {
            setBlueColorIndex(0);
            handleCalculate(playersCount);
            setYear(false)
        }
    }

    const handleClick = () => {
        if (year) {
            setYear(false)
        } else {
            setYear(true)
        }
    }

    const handleCalculate = (count) => {
        if (year) {
            setTotalCount(blueColorIndex * count * 10);
        } else {
            setTotalCount(blueColorIndex * count);
        }
    }

    useEffect(() => {
        handleCalculate(playersCount);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [blueColorIndex, year])

    const handleProcess = () => {
        setInitialValues({ numberOfPlayers: playersCount })
        setProcess(true);
    }

    return (
        <Dialog
            open={open}
            onClose={() => handleClose()}
            maxWidth="md"
            fullWidth
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Grid item xs={12} sm={12} md={12}>
                <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                    <ModalCloseButton
                        style={{ position: "static", margin: "0.3rem" }}
                        onClick={() => handleClose()}
                    />
                </Box>
            </Grid>
            <DialogContent style={{ margin: '0 2rem 0 2rem' }}>
                {process ? <CheckoutSubscription setProcess={setProcess} totalPrice={totalCount} playersCount={playersCount} year={year} paymentPlan={blueColorIndex} /> :
                    <Grid item xs={12} sm={12} md={12} container>
                        <Grid item xs={12} sm={12} md={12}>
                            <Box sx={{ textAlign: "center" }}>
                                <p className={styles.SubscriptionsText}>Extra Player Pricing</p>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12}>
                            <Formik
                                initialValues={initialValues}
                                validationSchema={PlayersSchema}
                            >
                                {({ dirty, isValid }) => {
                                    return (
                                        <Form>
                                            <Box className={styles.TopBorder}>
                                                <Grid item xs={12} sm={12} md={12} container>
                                                    <Grid item xs={2} sm={2} md={2} style={{ padding: '1px' }}>
                                                        <Box className={styles.NormalBorder} sx={{ height: 120, display: "flex", alignItems: "center", justifyContent: 'center' }}>
                                                            <p className={styles.TextBold}>Patients</p>
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={2} sm={2} md={2} style={{ padding: '1px' }}>
                                                        <Box className={styles.NormalBorder} sx={{ height: 120, display: "flex", alignItems: "center", justifyContent: 'center' }}>
                                                            <p className={styles.TextBold}>1 - 25</p>
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={2} sm={2} md={2} style={{ padding: '1px' }}>
                                                        <Box className={styles.NormalBorder} sx={{ height: 120, display: "flex", alignItems: "center", justifyContent: 'center' }}>
                                                            <p className={styles.TextBold}>26 - 50</p>
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={2} sm={2} md={2} style={{ padding: '1px' }}>
                                                        <Box className={styles.NormalBorder} sx={{ height: 120, display: "flex", alignItems: "center", justifyContent: 'center' }}>
                                                            <p className={styles.TextBold}>51 - 100</p>
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={2} sm={2} md={2} style={{ padding: '1px' }}>
                                                        <Box className={styles.NormalBorder} sx={{ height: 120, display: "flex", alignItems: "center", justifyContent: 'center' }}>
                                                            <p className={styles.TextBold}>101 - 200</p>
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={2} sm={2} md={2} style={{ padding: '1px' }}>
                                                        <Box className={styles.NormalBorder} sx={{ height: 120, display: "flex", alignItems: "center", justifyContent: 'center' }}>
                                                            <p className={styles.TextBold}>200 +</p>
                                                        </Box>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={12} container>
                                                    <Grid item xs={2} sm={2} md={2} style={{ padding: '1px' }}>
                                                        <Box className={styles.NormalBorder} sx={{ height: 120, display: "flex", alignItems: "center", justifyContent: 'center' }}>
                                                            <p className={styles.TextBold}>Monthly</p>
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={2} sm={2} md={2} style={{ padding: '1px' }}>
                                                        <Box className={blueColorIndex === 50 && !year ? styles.MarkBorder : !year ? styles.NormalBorder : styles.NormalBorderClicked} sx={{ height: 120, display: "flex", alignItems: "center", justifyContent: 'center' }} onClick={() => year ? handleClick() : null}>
                                                            <p>$50</p>
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={2} sm={2} md={2} style={{ padding: '1px' }}>
                                                        <Box className={blueColorIndex === 47.5 && !year ? styles.MarkBorder : !year ? styles.NormalBorder : styles.NormalBorderClicked} sx={{ height: 120, display: "flex", alignItems: "center", justifyContent: 'center' }} onClick={() => year ? handleClick() : null}>
                                                            <p>$47.5</p>
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={2} sm={2} md={2} style={{ padding: '1px' }}>
                                                        <Box className={blueColorIndex === 45 && !year ? styles.MarkBorder : !year ? styles.NormalBorder : styles.NormalBorderClicked} sx={{ height: 120, display: "flex", alignItems: "center", justifyContent: 'center' }} onClick={() => year ? handleClick() : null}>
                                                            <p>$45</p>
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={2} sm={2} md={2} style={{ padding: '1px' }}>
                                                        <Box className={blueColorIndex === 40 && !year ? styles.MarkBorder : !year ? styles.NormalBorder : styles.NormalBorderClicked} sx={{ height: 120, display: "flex", alignItems: "center", justifyContent: 'center' }} onClick={() => year ? handleClick() : null}>
                                                            <p>$40</p>
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={2} sm={2} md={2} style={{ padding: '1px' }}>
                                                        <Box className={blueColorIndex === 35 && !year ? styles.MarkBorder : !year ? styles.NormalBorder : styles.NormalBorderClicked} sx={{ height: 120, display: "flex", alignItems: "center", justifyContent: 'center' }} onClick={() => year ? handleClick() : null}>
                                                            <p>$35</p>
                                                        </Box>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={12} container>
                                                    <Grid item xs={2} sm={2} md={2} style={{ padding: '1px' }}>
                                                        <Box className={styles.NormalBorder} sx={{ height: 120, display: "flex", alignItems: "center", justifyContent: 'center' }}>
                                                            <p className={styles.TextBold}>Yearly</p>
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={2} sm={2} md={2} style={{ padding: '1px' }}>
                                                        <Box className={blueColorIndex === 50 && year ? styles.MarkBorder : year ? styles.NormalBorder : styles.NormalBorderClicked} sx={{ height: 120, display: "flex", alignItems: "center", justifyContent: 'center' }} onClick={() => !year ? handleClick() : null}>
                                                            <p>$500</p>
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={2} sm={2} md={2} style={{ padding: '1px' }}>
                                                        <Box className={blueColorIndex === 47.5 && year ? styles.MarkBorder : year ? styles.NormalBorder : styles.NormalBorderClicked} sx={{ height: 120, display: "flex", alignItems: "center", justifyContent: 'center' }} onClick={() => !year ? handleClick() : null}>
                                                            <p>$475</p>
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={2} sm={2} md={2} style={{ padding: '1px' }}>
                                                        <Box className={blueColorIndex === 45 && year ? styles.MarkBorder : year ? styles.NormalBorder : styles.NormalBorderClicked} sx={{ height: 120, display: "flex", alignItems: "center", justifyContent: 'center' }} onClick={() => !year ? handleClick() : null}>
                                                            <p>$450</p>
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={2} sm={2} md={2} style={{ padding: '1px' }}>
                                                        <Box className={blueColorIndex === 40 && year ? styles.MarkBorder : year ? styles.NormalBorder : styles.NormalBorderClicked} sx={{ height: 120, display: "flex", alignItems: "center", justifyContent: 'center' }} onClick={() => !year ? handleClick() : null}>
                                                            <p>$400</p>
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={2} sm={2} md={2} style={{ padding: '1px' }}>
                                                        <Box className={blueColorIndex === 35 && year ? styles.MarkBorder : year ? styles.NormalBorder : styles.NormalBorderClicked} sx={{ height: 120, display: "flex", alignItems: "center", justifyContent: 'center' }} onClick={() => !year ? handleClick() : null}>
                                                            <p>$350</p>
                                                        </Box>
                                                    </Grid>
                                                </Grid>
                                                {addMore ?
                                                    <Grid item xs={12} sm={12} md={12} container>
                                                        <Grid item xs={6} sm={6} md={6} style={{ padding: '1px' }}>
                                                            <Box sx={{ height: 100, display: "flex", alignItems: "center", justifyContent: 'center' }}>
                                                                <Grid item xs={9} sm={9} md={9} container>
                                                                    <Grid item xs={3} sm={3} md={3}>
                                                                        <p className={styles.TextBlue}>Add</p>
                                                                    </Grid>
                                                                    <Grid item xs={5} sm={5} md={5}>
                                                                        <Field
                                                                            style={{
                                                                                fontFamily: "Poppins",
                                                                            }}
                                                                            onKeyUp={handleChangePlayers}
                                                                            name="numberOfPlayers"
                                                                            component={TextField}
                                                                            variant="outlined"
                                                                            fullWidth
                                                                            margin="dense"
                                                                        ></Field>
                                                                    </Grid>
                                                                    <Grid item xs={4} sm={4} md={4}>
                                                                        <p className={styles.TextBlue}>patients</p>
                                                                    </Grid>
                                                                </Grid>
                                                            </Box>
                                                        </Grid>
                                                        <Grid item xs={6} sm={6} md={6} style={{ padding: '1px' }}>
                                                            <Box sx={{ height: 100, display: "flex", alignItems: "center", justifyContent: 'center' }}>
                                                                <Grid item xs={8} sm={8} md={8} container>
                                                                    <Grid item xs={8} sm={8} md={8} style={{ display: "flex", justifyContent: "flex-end" }}>
                                                                        <p className={styles.TextBlue}>Amount Due : </p>
                                                                    </Grid>
                                                                    <Grid item xs={4} sm={4} md={4} >
                                                                        <p className={styles.TextBlue}>$ {totalCount}</p>
                                                                    </Grid>
                                                                </Grid>
                                                            </Box>
                                                        </Grid>
                                                    </Grid>
                                                    :
                                                    <Grid item xs={12} sm={12} md={12} container justifyContent="center">
                                                        <Box sx={{ height: 100, display: "flex", alignItems: "center", justifyContent: 'center' }}>

                                                            <Grid item xs={10} sm={10} md={10}>
                                                                <p className={styles.TextBlue}>Your current plan contains 25 patients</p>
                                                            </Grid>
                                                            <Grid item xs={2} sm={2} md={2}>
                                                                <Button fullWidth size="large" onClick={() => setAddMore(true)}
                                                                    style={{
                                                                        fontSize: "0.9rem",
                                                                        lineHeight: "1.25rem",
                                                                        fontFamily: "Poppins",
                                                                        fontWeight: 500,
                                                                        fontStyle: "normal",
                                                                        width: 100,
                                                                        height: 40,
                                                                        backgroundColor: "#0F9BB0",
                                                                        color: "white",
                                                                        textTransform: "none",
                                                                    }}>Add More</Button>
                                                            </Grid>
                                                        </Box>
                                                    </Grid>}
                                            </Box>
                                            <Grid item xs={12} sm={12} md={12} container style={{ display: "flex", justifyContent: "flex-end", margin: "1rem 0 1rem 0" }}>
                                                {addMore ?
                                                    <Button fullWidth size="large" disabled={!isValid} onClick={() => handleProcess()}
                                                        style={isValid ? {
                                                            fontSize: "0.9rem",
                                                            lineHeight: "1.25rem",
                                                            fontFamily: "Poppins",
                                                            fontWeight: 400,
                                                            fontStyle: "normal",
                                                            width: 100,
                                                            height: 40,
                                                            backgroundColor: "#0F9BB0",
                                                            color: "white",
                                                            textTransform: "none",
                                                        } : {
                                                            fontSize: "0.9rem",
                                                            lineHeight: "1.25rem",
                                                            fontFamily: "Poppins",
                                                            fontWeight: 400,
                                                            fontStyle: "normal",
                                                            width: 100,
                                                            opacity: 0.5,
                                                            height: 40,
                                                            backgroundColor: "#0F9BB0",
                                                            color: "white",
                                                            textTransform: "none",
                                                        }}>Proceed</Button> : null}
                                            </Grid>
                                        </Form>
                                    )
                                }}
                            </Formik>
                        </Grid>
                    </Grid>}
                <Grid item xs={12} sm={12} md={12}>
                    {alert.showAlert ? (
                        <Snackbar
                            severity={alert.severity}
                            fullWidth
                            onClose={() =>
                                setAlert({
                                    ...alert,
                                    showAlert: false,
                                })
                            }
                        >
                            {alert.message}
                        </Snackbar>
                    ) : null}
                </Grid>
            </DialogContent>
        </Dialog >
    );
}
